import { formatHtml } from "@trumpf/ux.common-storybook";
import { TeaserMagazineTemplate } from "./teaser-magazine.templates";

export default {
    title: "Website/Partial Templates/Teaser/Magazine",
    render: TeaserMagazineTemplate.bind({}),
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    args: {
        variant: "default",
    },
    argTypes: {
        variant: {
            options: ["default", "blue"],
            control: { type: "radio" },
        },
    },
};

export const Default = {};
